(() => {
  [
    'pushState',
    'replaceState',
  ].forEach((methodName) => {
    // We store the original method
    const originalMethod = window.history[methodName];

    // We trigger our custom event
    window.swinger.eventHub.trigger(window, methodName.toLowerCase());

    // We execute the original method
    window.history[methodName] = (...args) => {
      originalMethod.apply(window.history, args);
    };
  });
})();
